import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import '../../App.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsSubmitting(true);

        try {
            const result = await login(email, password);

            if (result.success) {
                const roleName = result.user.role_details?.name;
                if (roleName === 'SUPER_ADMIN' || result.user.is_superuser) {
                    navigate('/');
                } else {
                    navigate('/fast-food/pos');
                }
            } else {
                setError(result.error || 'Credenciales inválidas. Por favor intente nuevamente.');
            }
        } catch (err) {
            setError('Error de conexión con el servidor. Intente de nuevo.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            width: '100vw',
            margin: 0,
            padding: '2rem 1rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'radial-gradient(100% 100% at 50% 0%, #e8f6f0 0%, #f7faf9 45%, #ffffff 100%)',
            position: 'relative',
            overflow: 'hidden',
            boxSizing: 'border-box'
        }}>
            <style>
                {`
                @keyframes floatIn {
                    0% { opacity: 0; transform: translateY(20px) scale(0.98); }
                    100% { opacity: 1; transform: translateY(0) scale(1); }
                }
                @keyframes pulseGlow {
                    0%, 100% { transform: scale(1); opacity: 0.5; }
                    50% { transform: scale(1.08); opacity: 0.8; }
                }
                .login-card {
                    animation: floatIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
                }
                .bana-input-wrapper {
                    position: relative;
                    display: flex;
                    align-items: center;
                }
                .bana-input-icon {
                    position: absolute;
                    left: 16px;
                    color: #8da399;
                    font-size: 1.15rem;
                    pointer-events: none;
                    transition: color 0.2s ease;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .bana-input {
                    width: 100%;
                    padding: 15px 48px 15px 48px;
                    border-radius: 14px;
                    border: 1.5px solid #d8ece2;
                    font-size: 0.975rem;
                    background-color: #ffffff;
                    color: #1e293b;
                    transition: all 0.25s ease;
                    outline: none;
                    box-sizing: border-box;
                }
                .bana-input:focus {
                    border-color: var(--primary-color);
                    background-color: #ffffff;
                    box-shadow: 0 0 0 4px rgba(169, 217, 195, 0.35);
                }
                .bana-input:focus + .bana-input-icon,
                .bana-input-wrapper:focus-within .bana-input-icon {
                    color: var(--primary-color);
                }
                .password-toggle-btn {
                    position: absolute;
                    right: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                    background: transparent;
                    border: none;
                    color: #64748b;
                    cursor: pointer;
                    width: 36px;
                    height: 36px;
                    padding: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 10px;
                    transition: all 0.2s ease;
                    z-index: 5;
                }
                .password-toggle-btn:hover {
                    color: var(--primary-color);
                    background-color: #eaf6f0;
                }
                .password-toggle-btn:active {
                    transform: translateY(-50%) scale(0.92);
                }
                .bana-submit-btn {
                    width: 100%;
                    padding: 15px;
                    font-size: 1.05rem;
                    font-weight: 700;
                    border-radius: 14px;
                    background-color: var(--primary-color);
                    color: #ffffff;
                    border: none;
                    cursor: pointer;
                    transition: all 0.25s ease;
                    box-shadow: 0 6px 18px rgba(46, 139, 107, 0.28);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 0.5rem;
                }
                .bana-submit-btn:hover:not(:disabled) {
                    transform: translateY(-2px);
                    box-shadow: 0 10px 24px rgba(46, 139, 107, 0.38);
                    background-color: var(--primary-hover);
                }
                .bana-submit-btn:active:not(:disabled) {
                    transform: translateY(0);
                }
                .bana-submit-btn:disabled {
                    opacity: 0.7;
                    cursor: not-allowed;
                }
                `}
            </style>

            {/* Elementos decorativos de fondo */}
            <div style={{
                position: 'absolute',
                top: '-15%',
                right: '-10%',
                width: '500px',
                height: '500px',
                borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(169, 217, 195, 0.45) 0%, rgba(255, 255, 255, 0) 70%)',
                animation: 'pulseGlow 8s ease-in-out infinite',
                pointerEvents: 'none'
            }} />
            <div style={{
                position: 'absolute',
                bottom: '-15%',
                left: '-10%',
                width: '450px',
                height: '450px',
                borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(216, 241, 230, 0.6) 0%, rgba(255, 255, 255, 0) 70%)',
                animation: 'pulseGlow 10s ease-in-out infinite alternate',
                pointerEvents: 'none'
            }} />

            {/* Tarjeta de Login Centrada */}
            <div 
                className="login-card"
                style={{ 
                    width: '100%', 
                    maxWidth: '460px', 
                    backgroundColor: '#ffffff',
                    boxShadow: '0 20px 45px -10px rgba(46, 139, 107, 0.12), 0 0 0 1px rgba(216, 236, 226, 0.8)', 
                    borderRadius: '24px',
                    padding: '3.25rem 2.75rem',
                    position: 'relative',
                    zIndex: 2,
                    boxSizing: 'border-box'
                }}
            >
                {/* Header con Logo */}
                <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                    <div style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '12px 24px',
                        borderRadius: '20px',
                        backgroundColor: '#fafcfb',
                        border: '1px solid #e8f4ee',
                        marginBottom: '1.25rem',
                        boxShadow: '0 2px 8px rgba(46, 139, 107, 0.04)'
                    }}>
                        <img 
                            src={require('../../assets/logo.png')} 
                            alt="Bana" 
                            style={{ 
                                height: '65px', 
                                width: 'auto',
                                maxWidth: '200px',
                                objectFit: 'contain',
                                display: 'block'
                            }} 
                        />
                    </div>
                    <h2 style={{ 
                        color: '#1b4332', 
                        fontSize: '1.75rem', 
                        fontWeight: '800', 
                        marginBottom: '6px', 
                        letterSpacing: '-0.5px' 
                    }}>
                        Iniciar Sesión
                    </h2>
                    <p style={{ 
                        color: '#64748b', 
                        fontSize: '0.95rem', 
                        fontWeight: '400',
                        margin: 0
                    }}>
                        Ingresa tus credenciales para acceder a Bana
                    </p>
                </div>

                {/* Alerta de Error */}
                {error && (
                    <div style={{ 
                        marginBottom: '1.5rem', 
                        borderRadius: '12px', 
                        padding: '12px 16px', 
                        backgroundColor: '#fef2f2', 
                        color: '#991b1b', 
                        border: '1px solid #fecaca',
                        fontSize: '0.9rem',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <i className="bi bi-exclamation-triangle-fill" style={{ color: '#dc2626', fontSize: '1rem', flexShrink: 0 }}></i>
                        <span>{error}</span>
                    </div>
                )}

                {/* Formulario */}
                <form onSubmit={handleSubmit} style={{ textAlign: 'left' }}>
                    <div className="form-group" style={{ marginBottom: '1.35rem' }}>
                        <label 
                            htmlFor="email" 
                            style={{ 
                                fontWeight: '600', 
                                color: '#1b4332', 
                                marginBottom: '8px', 
                                display: 'block', 
                                fontSize: '0.875rem',
                                letterSpacing: '0.2px' 
                            }}
                        >
                            Correo Electrónico
                        </label>
                        <div className="bana-input-wrapper">
                            <i className="bi bi-envelope bana-input-icon"></i>
                            <input
                                type="email"
                                id="email"
                                className="bana-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder="ejemplo@correo.com"
                                autoFocus
                            />
                        </div>
                    </div>

                    <div className="form-group" style={{ marginBottom: '2rem' }}>
                        <label 
                            htmlFor="password" 
                            style={{ 
                                fontWeight: '600', 
                                color: '#1b4332', 
                                marginBottom: '8px', 
                                display: 'block', 
                                fontSize: '0.875rem',
                                letterSpacing: '0.2px' 
                            }}
                        >
                            Contraseña
                        </label>
                        <div className="bana-input-wrapper">
                            <i className="bi bi-lock bana-input-icon"></i>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                id="password"
                                className="bana-input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="••••••••"
                            />
                            <button
                                type="button"
                                className="password-toggle-btn"
                                onClick={() => setShowPassword(!showPassword)}
                                title={showPassword ? 'Ocultar contraseña' : 'Ver contraseña'}
                                aria-label={showPassword ? 'Ocultar contraseña' : 'Ver contraseña'}
                                tabIndex={-1}
                            >
                                {showPassword ? (
                                    /* Icono Ojo Tachado (Ocultar) */
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z"/>
                                        <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829"/>
                                        <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z"/>
                                    </svg>
                                ) : (
                                    /* Icono Ojo (Mostrar) */
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"/>
                                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
                                    </svg>
                                )}
                            </button>
                        </div>
                    </div>

                    <button 
                        type="submit" 
                        className="bana-submit-btn"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? (
                            <>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ width: '1rem', height: '1rem' }}></span>
                                <span>Accediendo...</span>
                            </>
                        ) : (
                            <>
                                <span>Ingresar</span>
                                <i className="bi bi-arrow-right-short" style={{ fontSize: '1.4rem' }}></i>
                            </>
                        )}
                    </button>
                </form>

                {/* Footer de la Tarjeta */}
                <div style={{
                    marginTop: '2.25rem',
                    paddingTop: '1.25rem',
                    borderTop: '1px solid #f0f7f3',
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '6px',
                    color: '#94a3b8',
                    fontSize: '0.8rem'
                }}>
                    <i className="bi bi-shield-check" style={{ color: 'var(--primary-color)', fontSize: '0.95rem' }}></i>
                    <span>Sistema Seguro • Bana POS</span>
                </div>
            </div>
        </div>
    );
};

export default Login;
